var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"iframe-container"}},[_c('iframe',{attrs:{"src":_vm.info.src,"scrolling":"yes","width":_vm.iframeWidth,"height":"2000px","id":"iframe"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }